import React, { useContext, useEffect,useRef } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from '@fortawesome/free-solid-svg-icons';
import Stepper from '../Stepper/Stepper';
import { GlobalContext } from '../../GlobalProvider';

const Modal = ({personalizedModal,handleModel,personalizedB,nav}) => {

  const {hotelData} = useContext(GlobalContext)

  useEffect(() => {
    if (personalizedB) {
      if (window.scrollY !== 0)
      scrollToTop(window.innerWidth>500?100:300);
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "visible";
    }
}, [personalizedB]);

const scrollToTop = (duration) => {
    const scrollHeight = window.scrollY;
    const scrollStep = Math.PI / (duration / 15);
    const cosParameter = scrollHeight / 2;
    let scrollCount = 0;
    let scrollMargin;

    const scrollInterval = setInterval(() => {
        if (window.scrollY !== 0) {
            scrollCount = scrollCount + 1;
            scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
            window.scrollTo(0, (scrollHeight - scrollMargin));
        } else {
            clearInterval(scrollInterval);
        }
    }, 15);
};
let urk  = hotelData?.photo || null
  return (
   <>
   {
    personalizedB &&  <div ref={personalizedModal} className={`absolute z-50 flex justify-center items-center outerModal top-0 left-0 bg-black bg-opacity-50 h-[100vh] w-[100vw] transition-opacity duration-1000 `}>
    <div  className="modal relative border w-[100%] md:w-[60%] h-[100vh]  xs:h-[90vh] lg:h-[80vh] bg-white shadow-lg rounded-lg relative transform transition-display duration-300 ease-in-out">

 {
  urk &&    <div className='avatar absolute hidden xs:block top-[-40px] left-[50%] transform -translate-x-1/2'>
  <img className="w-20 h-[80px] rounded-full" src={urk} alt="Rounded avatar"/>
  </div>
 }
  <div className="header flex flex-row-reverse p-3 border-b-0 ">
   <div className="close w-[10%]">
   <FontAwesomeIcon onClick={handleModel} color="black" className="text-lg" icon={faClose} />
   </div>

  
  </div>
{/* Here add Body====================== */}
<Stepper handleModel={handleModel} nav={nav}/>
{/* BodyENd============================ */}
    </div>
  </div>
   }
   </>
  )
}

export default Modal
